import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from './common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeLogId, checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function Airdrop() {
    let dark = useSelector((state) => { return state.Darkmode.value });
    let log_id = useSelector((state) => { return state.log_id.value });

    const [search, setSearch] = useState(String(log_id).length > 0 ? String(log_id) : "")
    const [select, setSelect] = useState(false)
    const [selectValue, setSelectValue] = useState("ID")
    const [page, setPage] = useState(1)
    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    const [data, setData] = useState([])
    const [dataList, setDataList] = useState([])

    const [withdrawModal, setWithdrawModal] = useState(false)
    const [clickId, setClickId] = useState([])


    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    const onChangeSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setReload(e => !e)
        }
    };

    useEffect(() => {
        setTimeout(() => {
            dispatch(changeLogId(""))
        }, 100)
    }, [])

    useEffect(() => {
        setPage(1)
        UpgradeData()
    }, [reload])

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/airdrop', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                console.log(tmp.data)
                setData(tmp?.data?.airdrop ?? [])
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    useEffect(() => {
        if (data && data.length > 0) {
            let filter = [];
            if (selectValue === "ID" && search.length > 0) {
                filter = data.filter((p) => {
                    if (p.user_id) return p.user_id.toString().includes(search);
                });
            } else {
                filter = data;
            }
            setDataList(filter);
        }
    }, [data])

    let filterData = dataList
    const [name1, setName1] = useState(1);
    const [name2, setName2] = useState(0);

    if (name1 === 1) {
        filterData.sort((a, b) => Number(b.id) - Number(a.id));
    }
    else if (name1 === 2) {
        filterData.sort((a, b) => Number(a.id) - Number(b.id));
    }
    if (name2 === 1) {
        filterData.sort((a, b) => Number(b.user_id) - Number(a.user_id));
    }
    else if (name2 === 2) {
        filterData.sort((a, b) => Number(a.user_id) - Number(b.user_id));
    }

    let slice_data = dataList.slice((page - 1) * 20, (page) * 20)

    return (
        <div className='main'>
            <Message message={message} />
            {withdrawModal && (<WithdrawModal darkname={darkname} setWithdrawModal={setWithdrawModal} clickId={clickId} setReload={setReload} />)}

            <div className={`main-box ${darkname}`}>
                <div className='member-1'>
                    <div className={`member-2-search ${darkname}`}>
                        <div className={`member-1-select ${darkname}`} onClick={() => setSelect(e => !e)}>
                            <div className={`member-1-select-1 ${darkname}`}>{selectValue}</div>
                            {
                                select
                                    ?
                                    <FontAwesomeIcon icon={faSortUp} />
                                    :
                                    <FontAwesomeIcon icon={faSortDown} />
                            }
                            {
                                select
                                    ? <>
                                        <div className='modal' onClick={() => setSelect(true)}></div>
                                        <div className={`member-1-select-box ${darkname}`}>
                                            <div onClick={() => { setSelectValue("ID"); setSelect(true) }}>ID</div>
                                        </div>
                                    </>
                                    :
                                    ""
                            }
                        </div>
                        <FontAwesomeIcon icon={faWindowMinimize} className='line' />
                        <div className={`member-2-search-1 ${darkname}`}>
                            <input value={search} onChange={onChangeSearch} placeholder='Search' onKeyDown={handleKeyPress} />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className='member-1-search-ico-3' />
                            {
                                search.length > 0
                                    ?
                                    <FontAwesomeIcon icon={faCircleXmark} className='member-1-search-ico-2' onClick={() => setSearch("")} />
                                    :
                                    ""
                            }
                        </div>
                    </div>
                    <div className={`search-btn ${darkname}`} onClick={() => setReload(e => !e)}>Search</div>
                </div>
                <div className={`member-2 ${darkname}`}>
                    <div className={`table-head ${darkname}`}>
                        <div className={name1 === 0 ? 'table-sort' : 'table-sort sort-color'}
                            onClick={() => { { setName1(name1 => name1 === 1 ? 2 : 1); setName2(0) } }}
                            style={{ width: "10%", minWidth: "100px" }}>
                            <span>no.</span>
                            <span style={{ paddingTop: "1px" }}>
                                <span className="index_sort-btn__eWsx8">
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className={`${name1 === 2 ? "fill-color" : ""}`} d="M0.342163 3L3.77567 3C3.96395 3 4.11658 2.85941 4.11658 2.68599C4.11658 2.62399 4.09665 2.56339 4.05932 2.5118L2.34257 0.139848C2.23813 -0.00444984 2.02647 -0.0434422 1.86981 0.0527565C1.83236 0.0757532 1.80023 0.105353 1.77526 0.139848L0.0585074 2.5118C-0.0459313 2.6561 -0.00359917 2.85106 0.153059 2.94726C0.20906 2.98165 0.274858 3 0.342163 3Z" fill={"#999"}>
                                        </path>
                                    </svg>
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className={`${name1 === 1 ? "fill-color" : ""}`} d="M3.77442 0H0.340911C0.152631 0 0 0.140589 0 0.314014C0 0.376008 0.0199222 0.436615 0.0572559 0.488197L1.77401 2.86015C1.87845 3.00445 2.09011 3.04344 2.24677 2.94724C2.28422 2.92425 2.31635 2.89465 2.34132 2.86015L4.05807 0.488197C4.16251 0.343899 4.12018 0.148937 3.96352 0.0527385C3.90752 0.0183503 3.84172 0 3.77442 0Z" fill={"#999"}>
                                        </path>
                                    </svg>
                                </span>
                            </span>
                        </div>

                        <div className={name2 === 0 ? 'table-sort' : 'table-sort sort-color'}
                            onClick={() => { { setName2(name2 => name2 === 1 ? 2 : 1); setName1(0) } }}
                            style={{ width: "10%", minWidth: "120px" }}>
                            <span>유저 아이디</span>
                            <span style={{ paddingTop: "1px" }}>
                                <span className="index_sort-btn__eWsx8">
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className={`${name2 === 2 ? "fill-color" : ""}`} d="M0.342163 3L3.77567 3C3.96395 3 4.11658 2.85941 4.11658 2.68599C4.11658 2.62399 4.09665 2.56339 4.05932 2.5118L2.34257 0.139848C2.23813 -0.00444984 2.02647 -0.0434422 1.86981 0.0527565C1.83236 0.0757532 1.80023 0.105353 1.77526 0.139848L0.0585074 2.5118C-0.0459313 2.6561 -0.00359917 2.85106 0.153059 2.94726C0.20906 2.98165 0.274858 3 0.342163 3Z" fill={"#999"}>
                                        </path>
                                    </svg>
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path className={`${name2 === 1 ? "fill-color" : ""}`} d="M3.77442 0H0.340911C0.152631 0 0 0.140589 0 0.314014C0 0.376008 0.0199222 0.436615 0.0572559 0.488197L1.77401 2.86015C1.87845 3.00445 2.09011 3.04344 2.24677 2.94724C2.28422 2.92425 2.31635 2.89465 2.34132 2.86015L4.05807 0.488197C4.16251 0.343899 4.12018 0.148937 3.96352 0.0527385C3.90752 0.0183503 3.84172 0 3.77442 0Z" fill={"#999"}>
                                        </path>
                                    </svg>
                                </span>
                            </span>
                        </div>

                        <div style={{ width: "20%", minWidth: "200px" }}>출금 요청 시간</div>
                        <div style={{ width: "30%", minWidth: "400px" }}>지갑 주소</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>출금 상태</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>지급</div>
                        <div>비고</div>
                    </div>
                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {
                            spinner
                                ?
                                <div className='spinner-modal'>
                                    <SyncLoader color="#003577" />
                                </div>
                                :
                                slice_data.length === 0
                                    ?
                                    <div className='data-nofound'>
                                        <img src='/img/img_nofound.png'></img>
                                        <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                        <p>NO RECORDS FOUND</p>
                                    </div>
                                    :
                                    <>
                                        {
                                            slice_data.map(function (a, i) {
                                                return (
                                                    <MemberItem key={i} item={a} darkname={darkname} dark={dark} setClickId={setClickId} setWithdrawModal={setWithdrawModal} />
                                                )
                                            })
                                        }
                                        <NewPage initialData={dataList} page={page} setPage={setPage} maxFirstPage={20} />
                                    </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, dark, setWithdrawModal, setClickId }) {
    const onClickData = async () => {
        setWithdrawModal(true)
        setClickId(item)
    }

    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.id}</div>
                <div className='right td' style={{ width: "10%", minWidth: "120px" }}>{item.user_id}</div>
                <div className='td' style={{ width: "20%", minWidth: "200px" }}>{item.req_date}</div>
                <div className='td' style={{ width: "30%", minWidth: "400px" }}>{item.wallet_address}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.status}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>
                    {
                        item.status == 'N'
                            ?
                            <div className="upgrade-btn" onClick={() => onClickData()}>출금</div>
                            :
                            ""
                    }
                </div>
                <div className='td'></div>
            </div>
        </>
    )
}

function WithdrawModal({ darkname, setWithdrawModal, clickId, setReload }) {
    const [inputBudget, setInputBudget] = useState("")
    const [inputTXID, setInputTXID] = useState("")

    const onChangeInputBudget = (e) => {
        setInputBudget(e.target.value)
    }
    const onChangeInputTXID = (e) => {
        const { value } = e.target
        const onlyNumber = value.replace(/[^0-9]/g, "")
        setInputTXID(onlyNumber)
    }

    const onSubmitUpdateLevel = async () => {
        // await axios.post(process.env.REACT_APP_API + '/api/airdrop', {
        //     airId: '',
        //     userId: clickId.user_id,
        //     txId: ''
        // }, {
        //     // headers: { Authorization: `Bearer ${JWT}` }
        // }).then((response) => {
        //     let tmp = response.data
        //     if (tmp?.code == 1000) {
        //         console.log(tmp.data)
        //         setReload(e => !e)
        //     }
        // }).catch((error) => {
        //     console.log(error)
        // })
    };

    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "450px" }}>
                    <div className='modal-1-header'>에어드랍 출금(ID: {clickId.user_id})</div>

                    <div style={{ marginBottom: "30px" }}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>TX ID</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={inputBudget} onChange={onChangeInputBudget} />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>수량</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={inputTXID} onChange={onChangeInputTXID} />
                            </div>
                        </div>
                    </div>
                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={() => { onSubmitUpdateLevel() }}>확인</div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setWithdrawModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Airdrop;